import { Position, VisualAlertPosition } from '@keepeek/commons';

function convertVisualAlertPositionToTagPosition(visualAlertsPosition) {
    switch (visualAlertsPosition) {
        case VisualAlertPosition.TopRight:
            return Position.TopRight;
        case VisualAlertPosition.BottomRight:
            return Position.BottomRight;
        case VisualAlertPosition.TopLeft:
            return Position.TopLeft;
        case VisualAlertPosition.BottomLeft:
            return Position.BottomLeft;
        default:
            return Position.TopRight;
    }
}

export { convertVisualAlertPositionToTagPosition };
//# sourceMappingURL=convertVisualAlertPositionToTagPosition.js.map
